'use strict';

const Reflux = require('@muzzylane/reflux');

const   AssignmentActions = require('../../actions/AssignmentActions'),
        ForgeError = require('../../util/error'),
        ErrorConsts = require('../../constants/error');

const Globals = require('../../../../app/globals');

let assignments = {};
let assignmentStats = {};
let action = {};
let error = null;

const AdminLtiAssignmentsStore = Reflux.createStore({
    listenables: AssignmentActions,
    init: function() {return},

    getState: function() {
        return {
            assignments: assignments,
            assignmentStats: assignmentStats,
            error: error,
            action: action
        }
    },

    emitStatus: function() {
        // console.log("activity store: EMIT");
        this.trigger(this.getState());
        action = {};
        //error = null;
    },

    onError: function(actionID, err) {
        action.id = actionID;

        if(err.status){
            switch(err.status){
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null});
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onGetLtiAssignmentsForUserCompleted: function(actionID, userId, assignmentData) {
        // console.log("onGetLtiAssignmentsForUserCompleted: ", actionID, userId, assignmentData);
        action.id = actionID;

        if(!!assignments[userId]) delete assignments[userId]; //needed?
        assignments[userId] = assignmentData;

        this.emitStatus();
    },

    onGetLtiAssignmentsForUserFailed: function(actionID, userId, err) {
        console.warn("onGetLtiAssignmentsForUserFailed: ", actionID, userId, err);
        this.onError(actionID, err);
    },

    onGetLtiAssignmentStatsCompleted: function(actionID, assignmentId, stats) {
        // console.log("onGetLtiAssignmentStatsCompleted:", actionID, assignmentId, stats);
        action.id = actionID;

        if(!!assignmentStats[assignmentId]) delete assignmentStats[assignmentId];
        assignmentStats[assignmentId] = stats;

        this.emitStatus();
    },

    onGetLtiAssignmentStatsFailed: function(actionID, assignmentId, err) {
        console.warn("onGetLtiAssignmentStatsFailed: ", actionID, assignmentId, err);
        this.onError(actionID, err);
    }
});

module.exports = AdminLtiAssignmentsStore;
